'use client';
import { ReactElement, useState } from 'react';
import parse from 'html-react-parser';
import { stripHtml } from 'utils/formatters';
import AccordionArrowIcon from './icons/AccordionArrowIcon';

interface AccordionPanelProps {
  headline: string;
  answer: string;
  startOpen: boolean;
}

export default function AccordionPanel({
  headline,
  answer,
  startOpen = false,
}: AccordionPanelProps): ReactElement {
  const [isExpanded, setExpanded] = useState<boolean>(startOpen);

  return (
    <div className={`accordion ${isExpanded ? 'open' : 'closed'}`}>
      <div className="accordion-header">
        <button
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'collapse accordion' : 'expand accordion'}
          className="accordion-toggle"
          onClick={() => setExpanded(!isExpanded)}
        >
          <h3 className="accordion-question">{stripHtml(headline)}</h3>
          <AccordionArrowIcon direction={isExpanded ? 'up' : 'down'} />
        </button>
      </div>
      <div className={`accordion-content ${isExpanded ? 'open' : 'closed'}`}>
        {parse(answer)}
      </div>
    </div>
  );
}
